<template lang="pug">
  .component-action-button
    ModalReveal(ref="prompt")
      slot(name="prompt")
      .row.columns(slot="footer")
        button.button(:disabled="disabled || spin", @click="callAction")
          span.fa.fa-spinner.fa-spin(v-if="spin", :class="{spin:spin}")
          span(v-else) Save
    button.action-button(:disabled="disabled || spin", :class="{colorClass,button}", @click="call")
      span.fa.fa-spinner.fa-spin(v-if="spin", :class="{spin:spin}")
      slot(v-else)
</template>

<script>
  import ModalReveal from '../foundation/ModalReveal'

  export default {
    name: 'ActionButton',
    components: {ModalReveal},
    data() {
      return {
        spin: false,
      }
    },
    methods: {
      call() {
        if (this.confirm) {
          this.$confirm('Are you sure?', `Do you really want to continue?`, () => {
            this.callAction()
          })
        } else if (this.$scopedSlots.prompt !== undefined) {
          this.$refs.prompt.openModal()
        } else {
          this.callAction()
        }
      },
      callAction() {
        this.spin = true
        this.action(this.value).then(() => {
          this.spin = false
          if (this.$scopedSlots.prompt !== undefined) {
            this.$refs.prompt.close()
          }
        }).catch(() => {
          this.spin = false
          if (this.$scopedSlots.prompt !== undefined) {
            this.$refs.prompt.close()
          }
        })
      }
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      colorClass: {
        type: String
      },
      button: {
        type: Boolean,
        default: true
      },
      action: {
        //type: Function,
        default: () => {
          return Promise.resolve()
        }
      },
      confirm: {
        type: Boolean,
        default: false
      },
      value: {
        default: null
      }
    }
  }
</script>

<style lang="sass">
  .component-action-button
    button
  //.fa
    color: white
</style>



// WEBPACK FOOTER //
// ActionButton.vue?587e6364